var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterfillable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15080_236204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7116 2.67311C24.76 3.09465 23.7508 3.37135 22.7173 3.494C23.7938 2.84881 24.6203 1.82711 25.0095 0.609777C23.9862 1.21704 22.8666 1.6449 21.6991 1.87486C20.748 0.861701 19.3932 0.228516 17.8937 0.228516C15.0145 0.228516 12.6802 2.56274 12.6802 5.4417C12.6802 5.85036 12.7264 6.2482 12.8152 6.62986C8.48246 6.41237 4.64107 4.33693 2.06971 1.18281C1.62105 1.95278 1.36397 2.84841 1.36397 3.8037C1.36397 5.61243 2.28441 7.20805 3.6832 8.14299C2.85531 8.11706 2.04564 7.89346 1.32178 7.49085C1.32148 7.51268 1.32148 7.53452 1.32148 7.55646C1.32148 10.0824 3.1185 12.1895 5.50335 12.6684C4.73565 12.8772 3.93039 12.9077 3.14907 12.7577C3.81244 14.8289 5.7378 16.3361 8.01902 16.3783C6.2348 17.7765 3.98684 18.61 1.54442 18.61C1.12356 18.61 0.708645 18.5852 0.300781 18.5371C2.6079 20.0163 5.3482 20.8794 8.29228 20.8794C17.8816 20.8794 23.1252 12.9354 23.1252 6.0463C23.1252 5.82018 23.1203 5.59536 23.1102 5.37182C24.1308 4.634 25.0117 3.72013 25.7116 2.67311",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15080_236204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.4108,
    height: 20.7455,
    fill: "inherit",
    transform: "translate(0.300781 0.146484)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterfillable);
export default __webpack_public_path__ + "static/media/twitterfillable.a809b966136f38b920ce299400ca6255.svg";
export { ForwardRef as ReactComponent };